import React from "react";
import useAlertFisiaConsent from "../../hook/useAlertFisiaConsent";

import { Container } from "./styles";

export function AlertFisia() {
  const { cookiesAlertFisia, setCookiesAlertFisia } = useAlertFisiaConsent();

  if (cookiesAlertFisia) return null;

  return (
    <Container>
      <nav className={`content ${!cookiesAlertFisia ? "on" : "close"}`}>
        <p>COMUNICADO IMPORTANTE - FISIA</p>

        <section>
          <p>Caro parceiro,</p>

          <p>
            A FISIA tem como principal objetivo a satisfação dos seus clientes,
            sempre focando seus esforços em garantir que os processos atendam os
            parceiros da melhor forma possível.
          </p>

          <p>
            Desta forma, comunicamos o encerramento de forma consensual e
            planejada, da parceria de quase uma década entre FISIA e HAFSPORTS,
            que contribuiu de forma significativa para o fortalecimento e
            expansão da marca no mercado nacional.
          </p>

          <p>
            Agradecemos imensamente pela colaboração e dedicação nesses anos de
            trabalho. Como parte desse movimento estratégico, o atendimento
            passará a ser realizado diretamente pela Operadora Alpar do Brasil
            S/A, empresa com 28 anos de experiência no segmento esportivo e
            logístico, parceira da Nike há 20 anos, com sede administrativa em
            Cachoeirinha-RS e centro de distribuição no Espírito Santo. Todas as
            mercadorias faturadas pela Alpar serão despachadas através deste CD
            com o CNPJ 04.896.434/0005-04.
          </p>

          <p>
            <strong>
              ESSA MUDANÇA NÃO DEVERÁ TRAZER QUALQUER TIPO DE IMPACTO PARA OS
              PEDIDOS DESTA E DAS COLEÇÕES FUTURAS.
            </strong>
          </p>

          <ul>
            <li>
              <p>
                Entregas de OUT/NOV/DEZ/25: serão realizadas pela distribuidora
                HAFSPORTS.
              </p>
            </li>
            <li>
              <p>
                Entregas das coleções Spring 26 e Summer 26 (Jan-Jun/2026): Já
                sob responsabilidade da Alpar.
              </p>
            </li>
            <li>
              <p>
                Coleções a partir de Fall 26: Vendas e entregas integralmente
                conduzidas pela Alpar.
              </p>
            </li>
          </ul>
          <p>
            <br />
          </p>
          <p>
            Em caso de dúvidas, seguem abaixo os contatos da equipe Alpar, que
            estarão à disposição para apoiá-los:
          </p>
          <p>
            <strong>Luis Fernando Silveira - Diretor Comercial</strong>
          </p>
          <p>Celular (51) 99135-1127 - e-mail: fernando@alpardobrasil.com.br</p>
          <p>
            <strong>Uglio Scaravaglione - Gerente Nacional de Vendas</strong>
          </p>
          <p>Celular (51) 99826-5912 - e-mail: uglio@alpardobrasil.com.br</p>
          <p>
            <br />
          </p>
          <p>São Paulo, 30/09/2025</p>
          <p>
            <br />
          </p>
          <p>
            <strong>CABRIELLA ARRUDA CHAMAS</strong>
          </p>
          <p>
            <strong>Diretora Comercial</strong>
          </p>
        </section>

        <div>
          <button type="button" onClick={() => setCookiesAlertFisia(true)}>
            Eu entendo
          </button>
          <a
            // eslint-disable-next-line
            target="_blank"
            href="https://alpar.sfo3.digitaloceanspaces.com/emailmarketing/15%20Out%20Carta%20Fisia%20Alpar%20NONECO.pdf"
            className="profile-details"
          >
            Ver documento completo
          </a>
        </div>
      </nav>
    </Container>
  );
}
